import { BookOpen, LifeBuoy, Mail, MessageCircle, Rocket } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { findActiveModule } from '@/lib/navigation';
import { SUPPORT_EMAIL, SUPPORT_WHATSAPP_URL } from '@/lib/support';
import { MANUAL_SECTIONS } from '@/features/help/manual';

/** Botão Suporte do cabeçalho: manual da plataforma (com atalho para o módulo atual) e contatos. */
export function SupportMenu() {
  const { pathname } = useLocation();
  const module = findActiveModule(pathname);
  const firstSegment = (path: string) => path.split('/')[1] ?? '';
  const section = module
    ? MANUAL_SECTIONS.find((s) => s.route && firstSegment(s.route) === firstSegment(module.to))
    : undefined;
  const hasContacts = Boolean(SUPPORT_EMAIL || SUPPORT_WHATSAPP_URL);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Suporte">
          <LifeBuoy />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>Suporte</DropdownMenuLabel>
        <DropdownMenuItem asChild>
          <Link to="/ajuda">
            <BookOpen /> Manual da plataforma
          </Link>
        </DropdownMenuItem>
        {module && section ? (
          <DropdownMenuItem asChild>
            <Link to={`/ajuda#${section.id}`}>
              <module.icon /> Ajuda sobre {module.label}
            </Link>
          </DropdownMenuItem>
        ) : null}
        <DropdownMenuItem asChild>
          <Link to="/ajuda#primeiros-passos">
            <Rocket /> Primeiros passos
          </Link>
        </DropdownMenuItem>
        {hasContacts ? (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">
              Falar com o suporte
            </DropdownMenuLabel>
            {SUPPORT_WHATSAPP_URL ? (
              <DropdownMenuItem asChild>
                <a href={SUPPORT_WHATSAPP_URL} target="_blank" rel="noreferrer">
                  <MessageCircle /> WhatsApp
                </a>
              </DropdownMenuItem>
            ) : null}
            {SUPPORT_EMAIL ? (
              <DropdownMenuItem asChild>
                <a href={`mailto:${SUPPORT_EMAIL}`}>
                  <Mail /> {SUPPORT_EMAIL}
                </a>
              </DropdownMenuItem>
            ) : null}
          </>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
